import PageTemplate from '../../../shared/PageTemplate/PageTemplate';

const LandingPage = () => {
  return <PageTemplate></PageTemplate>;
};

export default LandingPage;
